/** @import modules */

import { createContext } from "react";

/** @export context */

export const ThemeContext = createContext ( null );